import ShopaholicProductList from '@lovata/shopaholic-product-list/shopaholic-product-list';
import ShopaholicPagination from '@lovata/shopaholic-product-list/shopaholic-pagination';
import ShopaholicSearch from '@lovata/shopaholic-search';
import UrlGeneration from '@lovata/url-generation';
import LazyLoad from '../../../../js/lazy-load';

export default new class searchComponent {
  constructor() {
    this.searchWrapper = 'search__wrapper';
    this.sSearchInput = '_page-search-input';
    this.preLoaderSearchSelector = '.page-search__preloader';
    this.pagePreLoaderSelector = '.search__preloader';
    this.initSearch();
    this.initPagination();
  }

  initSearch() {
    const obHelper = new ShopaholicSearch();
    $(document)
      .on('input', `.${this.sSearchInput}`, (obEvent) => {
        this.sSearchString = $(obEvent.currentTarget)
          .val();
        obHelper.processSearchString(this.sSearchString);
      });
    obHelper.setSearchDelay(600).setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = { 'product/search/search-ajax': `.${this.searchWrapper}` };
      obRequestData.loading = this.preLoaderSearchSelector;
      obRequestData.complete = () => {
        LazyLoad.update();
        this.updateUrl();
      };
      /* eslint-enable */
      return obRequestData;
    }).init();
  }

  updateUrl() {
    UrlGeneration.init();
    UrlGeneration.set('search', this.sSearchString);
    UrlGeneration.update();
  }

  initPagination() {
    const obListHelper = new ShopaholicProductList();
    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = { 'product/search/search-ajax': `.${this.searchWrapper}` };
      obRequestData.complete = () => {
        LazyLoad.update();
      };
      obRequestData.loading = this.pagePreLoaderSelector;
      /* eslint-enable */
      return obRequestData;
    });

    const obPaginationHelper = new ShopaholicPagination(obListHelper);
    obPaginationHelper.init();
  }
}();
